import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import {
    DefaultDataService,
    HttpUrlGenerator,
    Logger,
    QueryParams,
} from 'ngrx-data';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { I1FilenetServices } from '../i1-filenet-services.service';
import { ChoiceList } from './choice-list-dto';
import { ACLServiceWeb } from '../ACLServices-web.service';

@Injectable({
    providedIn: 'root',
})
export class ChoiceListDataService extends DefaultDataService<ChoiceList> {
    constructor(
        http: HttpClient,
        httpUserGenerator: HttpUrlGenerator,
        @Optional() logger: Logger,
        private i1FilenetServices: I1FilenetServices,
        private aclService: ACLServiceWeb
    ) {
        super('ChoiceList', http, httpUserGenerator);
    }

    getWithQuery(queryParams: QueryParams): Observable<ChoiceList[]> {
        const os = queryParams.objectStore as string;
        const choiceList = queryParams.choiceList as string;
        const gerritService = queryParams.gerritService as string;

        if (choiceList === 'allAuditUsers') {
            // console.log('Getting all users');
            return this.i1FilenetServices.getAuditUsers().pipe(
                map(v => {
                    return [
                        {
                            id: choiceList,
                            value: v.reduce((acc, row) => {
                                const value = row.split('@')[0];
                                acc[value] = value;
                                return acc;
                            }, {}),
                        },
                    ];
                })
                // tap(v => console.log('v2', v))
            );
        }

        if (choiceList === 'allUsers') {
            // console.log('Getting all users');
            return this.i1FilenetServices.getUsers().pipe(
                map(v => {
                    return [
                        {
                            id: choiceList,
                            value: v.reduce((acc, row) => {
                                const value = row.split('@')[0];
                                acc[value] = value;
                                return acc;
                            }, {}),
                        },
                    ];
                })
                // tap(v => console.log('v2', v))
            );
        }

        if (gerritService === 'Folder') {
            return this.i1FilenetServices
                .getFolderNames(os, choiceList)
                .pipe(map(v => [{ id: choiceList, value: v }]));
        }

        if (gerritService) {
            return this.aclService[gerritService]().pipe(
                map(v => [{ id: choiceList, value: v }])
            );
        }

        return this.i1FilenetServices
            .getChoiceListEntries(os, choiceList)
            .pipe(map(v => [{ id: choiceList, value: v }]));
    }
}
